namespace TabAurous.Scheme {
    export interface SchemeEnrollmentRow {
        SchemeEnrollmentId?: number;
        POSCustomerId?: number;
        SchemeId?: number;
        SchemeAmount?: number;
        Tenure?: number;
        BonusValue?: number;
        IsCancelled?: boolean;
        IsMatured?: boolean;
        IsRedeemed?: boolean;
        SchemeCode?: string;
        PosCustomerCode?: string;
    }

    export namespace SchemeEnrollmentRow {
        export const idProperty = 'SchemeEnrollmentId';
        export const localTextPrefix = 'Scheme.SchemeEnrollment';
        export const deletePermission = 'Scheme:Enrollment:Delete';
        export const insertPermission = 'Scheme:Enrollment:Add';
        export const readPermission = '*';
        export const updatePermission = 'Scheme:Enrollment:Edit';

        export declare const enum Fields {
            SchemeEnrollmentId = "SchemeEnrollmentId",
            POSCustomerId = "POSCustomerId",
            SchemeId = "SchemeId",
            SchemeAmount = "SchemeAmount",
            Tenure = "Tenure",
            BonusValue = "BonusValue",
            IsCancelled = "IsCancelled",
            IsMatured = "IsMatured",
            IsRedeemed = "IsRedeemed",
            SchemeCode = "SchemeCode",
            PosCustomerCode = "PosCustomerCode"
        }
    }
}
